import { render, staticRenderFns } from "./KedvezmenyekB2.vue?vue&type=template&id=f685e49e&"
import script from "./KedvezmenyekB2.vue?vue&type=script&lang=js&"
export * from "./KedvezmenyekB2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports